import { getImageData, IGetImageDataArgs, IUrlBuilderArgs } from "gatsby-plugin-image";
import React from "react";

// Creates a Contentstack image url
const createUrl = (imgUrl: string, options: Record<string, unknown> = {}) => {
  const queryParams: Record<string, unknown> = {
    width: options.width,
    height: options.height,
    format: options.toFormat,
    quality: options.quality,
    crop: options.crop,
    fit: options.fit,
    trim: options.trim,
    pad: options.pad,
    auto: options.auto,
    "bg-color": options.background,
  };

  const searchParams = new URLSearchParams();
  for (const key in queryParams) {
    if (typeof queryParams[key] !== "undefined") {
      searchParams.append(key, `${queryParams[key] ?? ""}`);
    }
  }
  return `${imgUrl}?${searchParams.toString()}`;
};

export function useContentstackImage({
  image,
  ...props
}: { image?: Record<string, any> } & Omit<IGetImageDataArgs, "baseUrl" | "urlBuilder">) {
  const defaultOptions = { auto: "webp" };
  const sourceRatio = image?.width / image?.height;
  return React.useMemo(
    () =>
      getImageData({
        baseUrl: image?.url,
        sourceWidth: image?.width,
        sourceHeight: image?.height,
        backgroundColor: image?.dominantColor,
        placeholderURL: createUrl(image?.url, { width: Math.floor(20 * sourceRatio), height: 20, ...defaultOptions }),
        urlBuilder: ({ baseUrl, width, height, options, format }: IUrlBuilderArgs<Record<string, unknown>>) =>
          createUrl(baseUrl, { ...options, height, width, toFormat: format }),
        pluginName: `no-plugin`,
        options: defaultOptions,
        ...props,
      }),
    [image?.url, image?.width, image?.height, props],
  );
}
